"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _forEach2 = _interopRequireDefault(require("lodash/forEach"));

var _find2 = _interopRequireDefault(require("lodash/find"));

var _keys2 = _interopRequireDefault(require("lodash/keys"));

var _constants = require("../constants");

var _browserDetection = _interopRequireDefault(require("../common/browser-detection"));

var _BrowserDetection = (0, _browserDetection.default)(),
    isBrowser = _BrowserDetection.isBrowser;

var StatsTransformer = {
  isFF: isBrowser('firefox')
}; // convert the ids from the parsed stats objects into understandable keys

StatsTransformer.simplify = function (stat) {
  return (0, _find2.default)((0, _keys2.default)(StatsTransformer.isFF ? _constants.DEFAULT_FF_TRANSFORM_REGEX : _constants.DEFAULT_TRANSFORM_REGEX), function (key) {
    var value;

    if (StatsTransformer.isFF) {
      // FF stats are formatted poorly so we have to take what we can get
      value = _constants.DEFAULT_FF_TRANSFORM_REGEX[key].regex.test("".concat(stat.type).concat(stat.kind ? "_".concat(stat.kind) : '', "_").concat(stat.id)) ? key : false;
    } else {
      // no other parameters necessary besides id
      value = _constants.DEFAULT_TRANSFORM_REGEX[key].regex.test(stat.id) ? key : false;
    }

    if (value) {
      // others were included but have a value that exclude them from the list because of duplicates that weren't chosen
      if (_constants.DEFAULT_TRANSFORM_REGEX[value].decider) {
        if (stat[_constants.DEFAULT_TRANSFORM_REGEX[value].decider] !== _constants.DEFAULT_TRANSFORM_REGEX[value].selector) {
          value = false;
        }

        return value;
      } // // some types need to check against a type field as well


      if (_constants.DEFAULT_TRANSFORM_REGEX[value].profiler) {
        var mapStatToReadableType = stat[_constants.DEFAULT_TRANSFORM_REGEX[value].profiler.type];

        if (!(mapStatToReadableType && mapStatToReadableType.includes(_constants.DEFAULT_TRANSFORM_REGEX[value].profiler.value) && value.toLowerCase().includes(_constants.DEFAULT_TRANSFORM_REGEX[value].profiler.value))) {
          value = false;
          return value;
        }
      }
    }

    return value;
  });
}; // parse the RTCStatsReport, extracting only the data we care about


StatsTransformer.parse = function (report) {
  var target = {}; // from the stats object
  // get the rtc stats report

  if (report && report.forEach && report.size > 0) {
    report.forEach(function (stat) {
      // each report has internal data
      if (stat && stat.type) {
        // pull only certain types
        if (_constants.DEFAULT_GET_STATS_FILTER.types.includes(stat.type)) {
          // insert into the target the statistic mapped to it's statical id
          target[stat.id] = stat;
        }
      }
    });
  }

  return target;
};

StatsTransformer.convert = function (parsed, options) {
  // supply your own simplification function (rather than id as the key)
  if (options.simplifyFn) {
    return options.simplifyFn(parsed);
  } // else use ours that stores things like rtcOutAudio, rtpInVideo, etc


  var target = {};
  (0, _forEach2.default)(parsed, function (stat) {
    var key = StatsTransformer.simplify(stat);

    if (key) {
      target[key] = stat;
    }
  });
  return target;
}; // transform the RTCStatsReport into a much more readable, processable format


StatsTransformer.transform = function (report) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    simplifyFn: undefined
  };
  var data; // first parse it and cut out not necessary data

  var parsed = StatsTransformer.parse(report); // either convert the data or store each stat with it's id mapped as the key to the stat object itself

  if (_constants.DEFAULT_TRANSFORM_REGEX) {
    data = StatsTransformer.convert(parsed, options);
  } else {
    data = parsed;
  }

  return data;
};

var _default = StatsTransformer;
exports.default = _default;
//# sourceMappingURL=transformer.js.map
